export default "__VITE_ASSET__DYSTGbqs__"